import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import appReducer from './slices/appSlice';
import tabsDataReducer from './slices/tabsDataSlice';
import othersDataReducer from './slices/othersDataSlice';
import ticReducer from './slices/ticSlice';
import currentTabReducer from './slices/currentTabSlice';
import currentPublicationReducer from './slices/currentPublicationSlice';
import newsReducer from './slices/newsSlice';
import paginationReducer from './slices/paginationSlice';
import quoteReducer from './slices/quoteSlice';
import mobileMenuReducer from './slices/mobileMenuSlice';
import cartReducer from './slices/cartSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    app: appReducer,
    tabs_data: tabsDataReducer,
    others_data: othersDataReducer,
    tic: ticReducer,
    currentTab: currentTabReducer,
    currentPublication: currentPublicationReducer,
    news: newsReducer,
    pagination: paginationReducer,
    quote: quoteReducer,
    mobileMenu: mobileMenuReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== 'production',
});
